import { render, staticRenderFns } from "./createDhlShipmentId.vue?vue&type=template&id=688e1b34&"
import script from "./createDhlShipmentId.vue?vue&type=script&lang=js&"
export * from "./createDhlShipmentId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports